// extracted by mini-css-extract-plugin
export default {"wrapper":"Opinkirjo_wrapper__-QjNw","image":"Opinkirjo_image__1BPky","alignCenter":"Opinkirjo_alignCenter__wv4EH","colAlign":"Opinkirjo_colAlign__oq2tg"};